import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ResultModal = ({
  title,
  text,
  warningText,
  show,
  btnClass,
  handleClose,
  closeBtnText = "ResultModal-Close-Btn",
}) => {
  const { t: translator } = useTranslation();
  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{translator(title)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{translator(text)}</p>
        <p>{warningText}</p>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={handleClose} type="button" className={btnClass}>
          {translator(closeBtnText)}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResultModal;
